var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCartBf1424 = function SvgShoppingCartBf1424(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BF1424",
    d: "M3.178 3 5.51 18.17q.027.188.104.355a1.25 1.25 0 0 0 1.155.725H20.5a1.25 1.25 0 0 0 1.197-.89l3.75-12.5a1.25 1.25 0 0 0-1.197-1.61H5.9l-.412-2.672a1.24 1.24 0 0 0-.433-.784A1.25 1.25 0 0 0 4.231.5H1.75a1.25 1.25 0 1 0 0 2.5zm4.644 13.75-1.538-10H22.57l-3 10zM10.5 23a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M21.75 23a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
  })));
};
export default SvgShoppingCartBf1424;